import clsx from "clsx";

interface EmpresaBadgeProps {
  razonSocial: string;
  nit: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export const EmpresaBadge = ({
  razonSocial,
  nit,
  onClick,
  className,
  disabled = false,
}: EmpresaBadgeProps) => {
  const content = (
    <>
      <span className="max-w-[180px] truncate font-semibold tracking-tight">
        {razonSocial}
      </span>
      <span className="ml-2 text-xs text-white/90 font-medium whitespace-nowrap">
        NIT {nit}
      </span>
    </>
  );

  const baseClasses =
    "inline-flex h-9 items-center rounded-lg bg-accent-blue px-3.5 text-sm font-medium text-white shadow-sm transition-all duration-200";

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-haspopup="dialog"
        aria-label={`Cambiar empresa. Actual: ${razonSocial}, NIT ${nit}`}
        className={clsx(
          baseClasses,
          "hover:bg-accent-blue/90 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-accent-blue/40 focus:ring-offset-1 active:scale-[0.97]",
          "disabled:cursor-not-allowed disabled:opacity-60",
          className
        )}
      >
        {content}
      </button>
    );
  }

  return <div className={clsx(baseClasses, className)}>{content}</div>;
};
